import React from 'react';
import { UiGrid, UiFlex, UiImage } from '@open-stack/ui';
import { ButtonGroup } from '../../../components/button/group/ButtonGroup';
import { useToggle } from '../../../hooks/toggle';
import { XPageHeader } from '../../../components/x/page/header/XPageHeader';
import { XText } from '../../../components/x/text/XText';
import { useApiTable } from '../../../hooks/useApiTable';
import { apiMeGetOrderHistoryPost } from '../../../api/me.getOrderHistory.[post]';
import { OrderIdPage } from '../id/OrderIdPage';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import { useRouter } from '../../../hooks/router';
import { XButton, XSection } from '@orderx/lab/ui';
import { XLoader } from '../../../components/x/loader/XLoader';
import { PaymentHistoryList } from '../../../components/payment/history/PaymentHistoryList';

export function OrderHistoryPage() {
    const [isPaymentsVisible, toggleIsPaymentsVisible] = useToggle(true);

    return (
        <>
            <XPageHeader title="Order history" />

            <XSection>
                <ButtonGroup>
                    <XButton
                        onClick={toggleIsPaymentsVisible}
                        variant={isPaymentsVisible ? 'filled' : 'text'}
                        color={isPaymentsVisible ? 'secondary' : 'default'}>
                        Payments
                    </XButton>

                    <XButton
                        onClick={toggleIsPaymentsVisible}
                        variant={isPaymentsVisible ? 'text' : 'filled'}
                        color={isPaymentsVisible ? 'default' : 'secondary'}>
                        Orders
                    </XButton>
                </ButtonGroup>
            </XSection>

            <XSection>{isPaymentsVisible ? <PaymentHistoryList /> : <OrderList />}</XSection>
        </>
    );
}

function OrderList() {
    const { replaceParams } = useRouter();

    const getData = useApiTable(
        (params) =>
            apiMeGetOrderHistoryPost({
                body: { ...params },
            }),
        {
            runOnInit: true,
            mapCellByType: {
                ROW: (order) => (
                    <NavLink
                        to={replaceParams(
                            OrderIdPage.route,
                            { orderId: order.id },
                            { linkBack: OrderHistoryPage.route },
                        )}
                        key={order.id}>
                        <UiFlex justifyContent="space-between">
                            <UiFlex gap={2}>
                                <UiImage
                                    src={order.outlet?.location.imageLogo}
                                    height={48}
                                    width={48}
                                    style={{ borderRadius: '100%' }}
                                />

                                <UiGrid gap={0}>
                                    <XText>{order.outlet?.location.name}</XText>
                                    <XText color="text-secondary">
                                        {moment(order.placedAt).format('D MMMM YYYY, HH:mm')}
                                    </XText>
                                </UiGrid>
                            </UiFlex>

                            <XButton icon="keyboard_arrow_right" variant="text" />
                        </UiFlex>
                    </NavLink>
                ),
            },
        },
    );

    return (
        <>
            {!getData.query.result && <XLoader />}
            {getData.table}
        </>
    );
}

OrderHistoryPage.route = '/order-history';
